import React, { memo } from 'react';
import classnames from 'classnames';

import { numberFormat } from '~/core/scripts/utils';
import { translate } from '../utils';
import config from '~/kits/general/scripts/config';

const YAxis = memo(({ margin, width, data, series, yScale, unit, drawTickLines }) => {
  const ticks = series.map(s => {
    const lastSeries = s[s.length - 1];
    const percentage = data[data.length - 1][`${s.key}_rel`];

    return {
      value: lastSeries[1] - (lastSeries[1] - lastSeries[0]) * 0.5,
      label: numberFormat(percentage, 1),
      display: percentage > 5,
      key: s.key.toLowerCase(),
      color: config[s.key].colorDark
    };
  });

  return (
    <g className="chart__yaxis chart__axis" transform={translate(width - margin.right, 0)}>
      {ticks
        .filter(d => d.display)
        .map(d => (
          <g
            className={classnames('tick', d.key)}
            transform={translate(0, ~~yScale(d.value) - 0.5)}
            key={`yaxis__${d.value}`}
            color={d.color}
          >
            {drawTickLines && <line stroke="currentColor" x2="-6" />}
            <text textAnchor="start" fill="currentColor" x="4" dy="0.32em">
              {d.label}
              {unit ? ` ${unit}` : ''}
            </text>
          </g>
        ))}
    </g>
  );
});

YAxis.displayName = 'YAxis';

export default YAxis;
